export default "__VITE_ASSET__1TGNrFEx__"